import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../utils";
import {
  Globe,
  Shield,
  Zap,
  ArrowRight,
  CheckCircle,
  Settings,
  BarChart3,
  Cloud,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

export default function Services() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("infrastructure");

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const serviceCategories = {
    infrastructure: {
      title: "Sistem Kami",
      icon: Settings,
      services: [
        {
          icon: Cloud,
          title: "ARJUNA",
          description: " Jual beli putus",
          features: [
            "Dalam system kami menawarkan jual beli program tersebut program tersebut di serahkan full ke client perorangan tersebut atau perusahaan tersebut. Untuk pricing ini di sesuaikan bagaimana Tingkat kesulitannya .",
          ],
          price: "Mulai dari Rp 5.000.000",
        },
        {
          icon: Shield,
          title: "SRIKANDI",
          description: "jual beli dengan sharing profit harga",
          features: [
            "program bisa dengan mou sharing profit dengan penghasilan perushaan dengan free pengembangan dan maintanence program",
          ],
          price: "Mulai dari Profit Sharing mulai 5% sampai 20%",
        },
        {
          icon: BarChart3,
          title: "PRAJURIT",
          description:
            "Konsultasi strategis untuk optimasi teknologi dan digital transformation",
          features: [
            "1-4 halaman include",
            "Bebas revisi Sepuasnya",
            "Sudah Termasuk Hosting",
          ],
          price: "Mulai dari Rp 200.000",
        },
      ],
    },
    
    
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-b from-gray-50/50 to-white">
        <div className="container mx-auto px-6 lg:px-8">
          <div
            className={`max-w-4xl mx-auto text-center transition-all duration-1000 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-8"
            }`}
          >
            <Badge
              variant="secondary"
              className="mb-6 px-4 py-2 bg-gray-100 text-gray-700 border-gray-200"
            >
              <Zap className="w-4 h-4 mr-2" />
              Solusi Komprehensif
            </Badge>

            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-gray-700 to-gray-900 bg-clip-text text-transparent">
                Layanan IT
              </span>
              <br />
              <span className="text-gray-900">Terlengkap</span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Dari konsep hingga implementasi, kami menyediakan solusi teknologi
              end-to-end yang disesuaikan dengan kebutuhan spesifik bisnis Anda.
            </p>
          </div>
        </div>
      </section>

      {/* Service Categories */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-8">
          {/* Tab Navigation */}
          <div className="flex justify-center mb-16">
            <div className="bg-gray-100 p-2 rounded-2xl flex border border-gray-200">
              {Object.entries(serviceCategories).map(([key, category]) => (
                <button
                  key={key}
                  onClick={() => setActiveTab(key)}
                  className={`flex items-center gap-2 px-6 py-3 rounded-xl transition-all duration-300 ${
                    activeTab === key
                      ? "bg-gray-700 text-white shadow-lg"
                      : "text-gray-700 hover:text-gray-900 hover:bg-gray-200"
                  }`}
                >
                  <category.icon className="w-5 h-5" />
                  {category.title}
                </button>
              ))}
            </div>
          </div>

          {/* Services Grid */}
          <div className="grid lg:grid-cols-3 gap-8">
            {serviceCategories[activeTab].services.map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-3xl p-8 border border-gray-200 hover:border-gray-300 hover:shadow-xl transition-all duration-300 hover:shadow-gray-500/10"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-gray-700 to-gray-800 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <service.icon className="w-8 h-8 text-white" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <div className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <div className="text-sm text-gray-600 mb-2">Investasi</div>
                  <div className="text-xl font-bold text-gray-900 mb-6">
                    {service.price}
                  </div>

                  <Link to={createPageUrl("Contact")}>
                    <Button className="w-full flex items-center justify-center group bg-gray-700 hover:bg-gray-800 text-white shadow-lg hover:shadow-gray-500/25">
                      <span>Konsultasi Gratis</span>
                      <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50/50">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Proses Kerja Kami
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Metodologi yang terbukti untuk mengantarkan proyek sesuai timeline
              dan budget
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                step: "01",
                title: "Konsultasi & Analisis",
                description:
                  "Memahami kebutuhan bisnis dan tantangan teknologi yang dihadapi",
              },
              {
                step: "02",
                title: "Planning & Design",
                description:
                  "Merancang solusi optimal dengan timeline dan budget yang jelas",
              },
              {
                step: "03",
                title: "Development & Testing",
                description:
                  "Pengembangan dengan metodologi agile dan quality assurance ketat",
              },
              {
                step: "04",
                title: "Deployment & Support",
                description:
                  "Implementasi live dan dukungan maintenance berkelanjutan",
              },
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gray-700 text-white rounded-2xl flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                  {process.step}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {process.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {process.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technologies */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Teknologi yang Kami Kuasai
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Stack teknologi modern dan reliable untuk setiap jenis proyek
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-8">
            {[
              "React",
              "Node.js",
              "Python",
              "AWS",
              "Docker",
              "MongoDB",
              "PostgreSQL",
              "TypeScript",
            ].map((tech, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-6 text-center hover:bg-white hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 bg-gray-200 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Globe className="w-6 h-6 text-gray-600" />
                </div>
                <div className="font-medium text-gray-900">{tech}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-700 to-gray-900">
        <div className="container mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Mulai Proyek IT Anda dengan Ghandiva
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            Konsultasi gratis untuk menentukan solusi teknologi yang paling
            sesuai dengan kebutuhan bisnis Anda
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to={createPageUrl("Contact")}>
              <Button
                size="lg"
                className="px-8 py-4 bg-white text-gray-700 hover:bg-gray-100 group shadow-lg flex items-center justify-center"
              >
                <span>Konsultasi Sekarang</span>
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>

            <Button
              size="lg"
              className="px-8 py-4 bg-gray-700 text-white hover:bg-gray-800 shadow-lg flex items-center justify-center"
            >
              <span>Download Portfolio</span>
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
